import { render, staticRenderFns } from "./SalutationSettings.vue?vue&type=template&id=cc43ed1e&"
import script from "./SalutationSettings.vue?vue&type=script&lang=js&"
export * from "./SalutationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports